var _rect, _rect2, _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_2131)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_2131)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_2131)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.4793C47.7176 20 46.2714 21.4474 46.2714 23.2105V32.6316H35.7272C34.018 32.6316 32.6244 34.0263 32.6244 35.7632V46.3158H23.132C21.3966 46.3158 20.0029 47.7105 20.0029 49.4474V56.8158C20.0029 58.5526 21.3966 59.9474 23.132 60H56.7893C58.551 60 59.9972 58.5526 59.9972 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "url(#paint2_linear_852_2131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.4793C47.7176 20 46.2714 21.4474 46.2714 23.2105V32.6316H35.7272C34.018 32.6316 32.6244 34.0263 32.6244 35.7632V46.3158H23.132C21.3966 46.3158 20.0029 47.7105 20.0029 49.4474V56.8158C20.0029 58.5526 21.3966 59.9474 23.132 60H56.7893C58.551 60 59.9972 58.5526 59.9972 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "url(#paint3_linear_852_2131)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_852_2131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_852_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7627 20H49.5317C47.7699 20 46.3237 21.4474 46.3237 23.2105V60H56.7627C58.5245 60 59.9707 58.5526 59.9707 56.7895V23.2105C59.9707 21.4474 58.5245 20 56.7627 20Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6244 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7369 20.0029 49.4737V56.8421C20.0029 58.579 21.4228 60 23.1583 60H46.2977V32.6316H35.7798C34.0443 32.6316 32.6244 34.0526 32.6244 35.7895Z",
    fill: "#A6A6C9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_852_2131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_852_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2979 32.6316V60H56.7369C58.4986 60 59.9448 58.5526 59.9448 56.7895V46.3158L46.2979 32.6316Z",
    fill: "url(#paint4_linear_852_2131)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_852_2131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_852_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.7799 32.8947H46.2978V32.6316H35.7799C34.0444 32.6316 32.6245 34.0526 32.6245 35.7895V36.0526C32.6245 34.3158 34.0444 32.8947 35.7799 32.8947Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_852_2131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_852_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.1583 46.5788H32.6244V46.3157H23.1583C21.4228 46.3157 20.0029 47.7367 20.0029 49.4736V49.7367C20.0029 47.9999 21.4228 46.5788 23.1583 46.5788Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_852_2131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_852_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.7627 20H49.5317C47.7699 20 46.3237 21.4474 46.3237 23.2105V23.4737C46.3237 21.7105 47.7699 20.2632 49.5317 20.2632H56.7627C58.5245 20.2632 59.9707 21.7105 59.9707 23.4737V23.2105C59.9707 21.4474 58.5245 20 56.7627 20Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_852_2131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_852_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.763 59.7369H23.1583C21.4228 59.7369 20.0029 58.3158 20.0029 56.579V56.8422C20.0029 58.579 21.4228 60 23.1583 60H56.7367C58.4984 60 59.9446 58.5527 59.9446 56.7895V56.5264C59.9709 58.2895 58.5247 59.7369 56.763 59.7369Z",
    fill: "#D9D9E8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.763 20H49.5319C47.7702 20 46.324 21.4474 46.324 23.2105V32.6316H35.8061C34.0706 32.6316 32.6507 34.0526 32.6507 35.7895V46.3158H23.1583C21.4228 46.3158 20.0029 47.7368 20.0029 49.4737V56.8421C20.0029 58.5789 21.4228 60 23.1583 60H56.763C58.5247 60 59.9709 58.5526 59.9709 56.7895V23.2105C59.9709 21.4474 58.5247 20 56.763 20Z",
    fill: "url(#paint5_linear_852_2131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_2131",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_2131",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_852_2131",
    x1: 20.0029,
    y1: 40,
    x2: 59.9972,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_852_2131",
    x1: 20.0029,
    y1: 40,
    x2: 59.9972,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_852_2131",
    x1: 39.527,
    y1: 39.5395,
    x2: 59.0296,
    y2: 59.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6C9",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACCD",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_852_2131",
    x1: 33.4051,
    y1: 33.4292,
    x2: 59.2803,
    y2: 59.2838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_2131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg19);
export default __webpack_public_path__ + "static/media/productivityimg19.ce2c80e171b8262d4271f491875d329d.svg";
export { ForwardRef as ReactComponent };